import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private currentLanguage = new BehaviorSubject<string>('en'); // default language
  currentLanguage$ = this.currentLanguage.asObservable();

  constructor(private translate: TranslateService, @Inject(DOCUMENT) private document: Document) {
    this.initLanguage(); // set default language class on load
  }

  private initLanguage() {
    const savedLang = localStorage.getItem('lang') || 'en'; // default to English
    this.translate.use(savedLang);
    this.currentLanguage.next(savedLang);
    this.updateBodyClass(savedLang);
  }

  changeLanguage(lang: string) {
    localStorage.setItem('lang', lang);
    this.translate.use(lang);
    this.currentLanguage.next(lang);
    this.updateBodyClass(lang);
  }

  private updateBodyClass(lang: string) {
    const body = this.document.body;
    body.classList.remove('english-font', 'arabic-font'); // remove previous font classes

    if (lang === 'ar') {
      body.classList.add('arabic-font');
    } else {
      body.classList.add('english-font');
    }
  }
}
